import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ThinkingModal from "modules/modal/thinking-modal";
import { isBlockingProcessesExists } from "modules/common/common-selectors";

/**
 * @return {null}
 */
function LoadingOverlay({ isLoading }) {
  return isLoading ? <ThinkingModal className="LoadingOverlay" /> : null;
}

LoadingOverlay.propTypes = {
  isLoading: PropTypes.bool
};

export default connect(state => ({
  isLoading: isBlockingProcessesExists(state)
}))(LoadingOverlay);



// WEBPACK FOOTER //
// ./src/modules/root/loading-overlay.js